import { Injectable } from "@nestjs/common";
import { EntityRepository, Repository } from "typeorm";

@EntityRepository(FileUploadRepository)
@Injectable()
export class FileUploadRepository extends Repository<FileUploadRepository> {

}